import { defineStore } from 'pinia';
import {
  apiCreateLinkToken,
  apiFetchCandidateJobName,
  apiFetchIntegrations,
  apiRetrieveAccountToken,
  apiSearchCandidates,
} from '@/api/offers-common';
import type { Integration } from '@/offers/types/offer';
import { type AtsCandidate, type FetchCandidateJobNameParams, type SearchCandidatesParams } from '@/types';

export const useMergeStore = defineStore('merge', {
  state: () => ({
    linkToken: '',
    accountToken: '',
    candidatesSearch: [] as AtsCandidate[],
    integrations: [] as Integration[],
    selectedCandidateJob: '',
  }),
  actions: {
    async createLinkToken() {
      const { data } = await apiCreateLinkToken();
      this.linkToken = data.link_token;
    },
    async retrieveAccountToken(publicToken: string) {
      console.log('fired');
      const { data } = await apiRetrieveAccountToken({ public_token: publicToken });
      this.accountToken = data.account_token;
    },
    async searchCandidates(params: SearchCandidatesParams) {
      const { data } = await apiSearchCandidates(params);

      this.candidatesSearch = data;
    },
    async fetchIntegrations() {
      const { data } = await apiFetchIntegrations();

      this.integrations = data;
    },
    async fetchCandidateJobName(params: FetchCandidateJobNameParams) {
      const { data } = await apiFetchCandidateJobName(params);

      this.selectedCandidateJob = data;
    },
  },
});
